//import Image from "next/image";
import React from "react";
import Timeline from "./timeline";

interface FutureProps {
  data?: any;
}
const Milestone = ({ data }: FutureProps) => {
  return (
    <section className=" bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[80px] ">

      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Heading */}
        <h2 className="text-heading-1 font-bold  text-center text-primary-text mb-[10px] md:mt-[0px] sm:max-w-[940px] max-w-[350px] mx-auto w-full">
          {data?.title}
        </h2>
        <p className="text-subtitle-2 font-normal text-primary-text mb-[40px] max-w-[940px] mx-auto">
          {data?.description}
        </p>       
      </div>
      
      <div className="sm:bg-[url('/images/about/bg-milestone.png')] bg-ipad-custom bg-[url('/images/about/timeline-mobile.png')] sm:bg-contain bg-cover bg-fixed  container px-0-custom ">
        {/* <div className="container mx-auto px-4 px-0-custom "> */}
        <Timeline data={data} />
      </div>
    </section>
  );
};

export default Milestone;
